import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertBmpToWebp() {
  return <ImageConverterTemplate sourceFormat="BMP" targetFormat="WebP" acceptTypes=".bmp,image/bmp" slug="convert-bmp-to-webp" gradientColors="from-green-500 to-teal-600" accentColor="green" showQualitySlider={true} />;
}
